import type { GenerateContext } from "../types.js";

export function generateNull(_ctx: GenerateContext): null {
  return null;
}
